import { Reveal } from "./Reveal";

export const Coverage = () => (
  <section id="coverage" className="py-24 px-6 md:px-10 bg-[#FAF6F0] border-b border-[#0D2121]/10" data-testid="coverage-section">
    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <Reveal className="lg:col-span-5 space-y-6">
        <span className="text-xs uppercase tracking-widest text-[#c88c2a] font-semibold">Service Reach</span>
        <h2 className="font-display text-3xl sm:text-4xl text-[#0D2121]">Where Griham Builds &amp; Consults</h2>
        <p className="text-[#7A6F66] text-base leading-relaxed" data-testid="coverage-description">
          We undertake turnkey site execution across a few cities nearby, and provide comprehensive online design consultations for clients anywhere.
        </p>
        <div className="space-y-3 text-sm">
          <div className="p-4 bg-[#F4EDE2] border border-[#0D2121]/10">
            <span className="font-semibold text-[#0D2121] block">On-Site Turnkey Projects</span>
            <span className="text-[#7A6F66] text-xs">Full supervision and fabrication in our primary operating region and neighboring cities.</span>
          </div>
          <div className="p-4 bg-[#F4EDE2] border border-[#0D2121]/10">
            <span className="font-semibold text-[#0D2121] block">Virtual Design Consultations</span>
            <span className="text-[#7A6F66] text-xs">Complete 3D plans, working drawings, and shopping curation for homes across India &amp; overseas.</span>
          </div>
        </div>
      </Reveal>

      <Reveal className="lg:col-span-7" delay={120}>
        <div className="aspect-[16/10] bg-[#EADBC8] border border-[#0D2121]/10 rounded-sm p-8 flex flex-col justify-between" data-testid="coverage-map-card">
          <div className="flex items-center justify-between text-xs font-semibold text-[#0D2121] uppercase tracking-wider">
            <span>Studio Coverage Network</span>
            <span className="px-2 py-1 bg-[#0D2121] text-[#E2A435]">Active Consultations</span>
          </div>
          <div className="space-y-2 text-center py-6">
            <div className="font-display text-2xl text-[#0D2121]">Regional On-Site + Digital Worldwide</div>
            <div className="text-xs text-[#7A6F66]">Tailored consultation packages based on your site location and floor plan.</div>
          </div>
          <div className="text-[11px] text-[#7A6F66] flex justify-between border-t border-[#0D2121]/10 pt-3">
            <span>Direct studio site visits</span>
            <span>Remote 3D drawing packages</span>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
